const { sortByNavOrder } = require('@/functions/arraySorting');

/**
 * This holds a single category and the items (or event buttons) that belong to that category.
 */
class CategoryItemList {
    /**
     * @param {Category} category
     * @param {{navOrder: number, event: SessionEvent, items: AbstractItem[]}[]} eventButtons
     * @param {AbstractItem[]} items
     */
    constructor(category, eventButtons = [], items = []) {
        this.category = category;

        /**
         * Event based tickets.
         *
         * @type {{navOrder: number, event: SessionEvent, items: AbstractItem[], matchingItems?: AbstractItem[]}[]}
         */
        this.eventButtons = eventButtons;
        sortByNavOrder(this.eventButtons);

        /**
         * Non-event items.
         *
         * @type {AbstractItem[]}
         */
        this.items = items;
        sortByNavOrder(this.items);

        this.count = this.eventButtons.length + this.items.length;

        /**
         * @type {number}
         */
        this.navOrder = category.navOrder;
    }
}

module.exports = CategoryItemList;
